import { Localization } from "@viamap/viamap2-common";

export function formatDate(dateString: string) {
   if (!dateString) return '';

   const parts = dateString.split('-');
   if (parts.length === 3) {
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];

      const isoDateString = `${year}-${month}-${day}`;
      const date = new Date(isoDateString);

      if (isNaN(date.getTime())) {
         return dateString;
      }

      const locale = Localization.getLocale();
      return date.toLocaleString(locale, {
         year: 'numeric',
         month: '2-digit',
         day: '2-digit'
      });
   }
   return dateString;
};